import { ReactElement } from "react";
import Logo from "../Logo";
import { Text } from "../Type";
import styles from "./index.module.scss";

type PropsType = {
  children: ReactElement | ReactElement[];
};

const Maintenance = ({ children }: PropsType) => {
  const message =
    "EASI is undergoing some maintenance and will return soon. Thank you for your patience.";

  return process.env.REACT_APP_MAINTENANCE_MODE === "true" ? (
    <div className={styles.content}>
      <Text size="large">
        {process.env.REACT_APP_MAINTENANCE_MESSAGE || message}
      </Text>
      <div className={styles.logo}>
        <Logo />
      </div>
    </div>
  ) : (
    <>{children}</>
  );
};

export default Maintenance;
